import React, { Component } from 'react';
import { Grid, Row, Col, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom'

const webProj =
{
    data: [
        {
            id: 1,
            title: 'LemonSqueeze',
            image: require('../images/lmsq-app-min.png'),
            link: 'https://desolate-badlands-48422.herokuapp.com/',
            overview: 'React Web app built using The Movie DataBase API 🎥',
            tech: [],
        },
        {
            id: 2,
            title: 'Material Design Card',
            image: require('../images/materialCard-min.png'),
            link: 'https://fabulous-lokum-328dd0.netlify.app/',
            overview: 'An interactive card I created as a solution to a online front end design challenge 💻',
            tech: [],
        },
        {
            id: 3,
            title: 'Relay App',
            image: require('../images/relay-app-min.png'),
            link: 'https://desolate-stream-11725.herokuapp.com/',
            overview: 'An e-commerce site built with React and the Moltin Database [Still In Development]',
            tech: [],
        },   
        {
            id: 4,
            title: 'Form Validation',
            image: require('../images/login-form-min.png'),
            link: 'https://snazzy-boba-031b9b.netlify.app/',
            overview: 'A login screen with validation for testing purposes',
            tech: [],
        },
        {
            id: 5,
            title: 'UI Toggle Design',
            image: require('../images/ui-switch.png'),
            link: 'https://vigilant-jennings-221be4.netlify.app/',
            overview: 'An interactive toggle switch. Give it a Try‼️',
            tech: [],
        },
        {
            id: 6,
            title: 'Raindrop',
            image: require('../images/raindrop-app-min.png'),
            link: 'https://fathomless-spire-16380.herokuapp.com/',
            overview: 'A weather Web App which uses the Open Weather Map API to give current weather details based on user input ',
            tech: [],
        },
        {
            id: 7,
            title: 'Tasky',
            image: require('../images/Tasky-min.png'),
            link: 'https://whispering-falls-54453.herokuapp.com/',
            overview: 'A to-do list',
            tech: [],
            
        },
        
    ]
}

class Projects extends Component {
    constructor(props) {
        super(props)
        this.state={
            didMount: false,
            data: '',
        }
    }

    componentDidMount() { 
        this.setState({ 
            didMount: true,
            data: webProj.data,
        })
        console.log(this.state.data)
    }

    render() {
        let ready = this.state.didMount;
        let allProjects = this.state.data;
        if (ready === false) {
            return (
                <div className="logo-cntnr">
                 <div class="loading-logo"></div>
            </div>
            )
        }
        return (
            <Grid className="projects-body">
                {allProjects.map((itm, index) => ( 
                    <Col md={4}>
                    
                   
                        <Link to={{
                            pathname: `/project/${itm.id}`,
                            state: {
                                key: index,
                                data: itm,
                                id: itm.id,
                                title: itm.title,
                                image: itm.image,
                            }
                        }}>
                            <img key={index} className="mockup" src={itm.image} alt="project"/>
                        </Link>
                        </Col>      
                    
                ))}
                </Grid>
                )
    
    }
}

export default Projects;

